import script from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=27e2ff08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27e2ff08"]])

export default __exports__